export const FIELD_TYPES = {
  TEXT: "text",
  SELECT: "select",
  DATE: "date",
};
export const MERCHANT_FIELDS = {
  merchantName: {
    label: "Merchant Name",
    placeholder: "Enter merchant name",
    type: FIELD_TYPES.TEXT,
    required: true,
    requiredInEdit: true,
    validation: { min: 3, max: 250 },
  },
  merchantAlias: {
    label: "Merchant Alias",
    placeholder: "Enter alias",
    type: FIELD_TYPES.TEXT,
    required: false,
    validation: { min: 3, max: 20 },
  },
  registrationNumber: {
    label: "Registration Number",
    placeholder: "Enter registration number",
    type: FIELD_TYPES.TEXT,
    required: true,
    validation: { min: 3, max: 50 },
  },
  nationality: {
    label: "Nationality",
    placeholder: "Enter nationality",
    type: FIELD_TYPES.TEXT,
    required: true,
    requiredInEdit: true,
    validation: { min: 3, max: 50 },
  },
  address: {
    label: "Address",
    placeholder: "Enter address",
    type: FIELD_TYPES.TEXT,
    required: true,
    requiredInEdit: true,
    validation: { min: 5, max: 200 },
  },
  country: {
    label: "Country",
    placeholder: "Select country",
    type: FIELD_TYPES.SELECT,
    required: true,
    requiredInEdit: true,
    validation: { max: 50 },
  },
  city: {
    label: "City",
    placeholder: "Enter city",
    type: FIELD_TYPES.TEXT,
    required: false,
    validation: { min: 3, max: 50 },
  },
  county: {
    label: "County",
    placeholder: "Enter county",
    type: FIELD_TYPES.TEXT,
    required: false,
    validation: { min: 3, max: 50 },
  },
  taxPin: {
    label: "Tax PIN",
    placeholder: "Enter tax PIN",
    type: FIELD_TYPES.TEXT,
    required: false,
    validation: { min: 3, max: 20 },
  },
  directors: {
    label: "Directors",
    placeholder: "e.g. John Doe, Jane Doe",
    type: FIELD_TYPES.TEXT,
    required: false,
    validation: { max: 250 },
  },
  shareholders: {
    label: "Shareholders",
    placeholder: "e.g. John Doe, Jane Doe",
    type: FIELD_TYPES.TEXT,
    required: false,
    validation: { max: 250 },
  },
  merchantType: {
    label: "Merchant Type",
    placeholder: "Select merchant type",
    type: FIELD_TYPES.SELECT,
    required: true,
    data: ["Individual", "Limited", "Sole Proprietorship", "Partnership"],
    validation: { max: 50 },
  },
  currency: {
    label: "Currency",
    placeholder: "Select currency",
    type: FIELD_TYPES.SELECT,
    required: true,
    data: ["KES"],
    validation: { max: 4 },
  },
  registrationDate: {
    label: "Registration Date",
    placeholder: "YYYY-MM-DD",
    type: FIELD_TYPES.DATE,
    required: true,
  },
  economicSector: {
    label: "Economic Sector",
    placeholder: "Enter economic sector",
    type: FIELD_TYPES.SELECT,
    required: true,
    isObjectField: true,
  },
  gender: {
    label: "Gender",
    placeholder: "Select gender",
    type: FIELD_TYPES.SELECT,
    required: true,
    isObjectField: true,
  },
  productTransactionCode: {
    label: "Product Transaction Code",
    placeholder: "Select product transaction code",
    type: FIELD_TYPES.SELECT,
    required: true,
    isObjectField: true,
  },
  productOwnership: {
    label: "Product Ownership Type",
    placeholder: "Select product ownership type",
    type: FIELD_TYPES.SELECT,
    required: true,
    isObjectField: true,
  },
  productCategory: {
    label: "Product Category",
    placeholder: "Select product category",
    type: FIELD_TYPES.SELECT,
    required: true,
    isObjectField: true,
  },
  email: {
    label: "Merchant Email",
    placeholder: "Enter email",
    type: FIELD_TYPES.TEXT,
    required: true,
    validation: { max: 100 },
  },
  phoneNumber: {
    label: "Merchant Phone Number",
    placeholder: "Enter phone number",
    type: FIELD_TYPES.TEXT,
    required: true,
  },
  merchantAdminFirstName: {
    label: "Admin First Name",
    placeholder: "Enter first name",
    type: FIELD_TYPES.TEXT,
    required: true,
    validation: { min: 3, max: 50 },
  },
  merchantAdminLastName: {
    label: "Admin Last Name",
    placeholder: "Enter last name",
    type: FIELD_TYPES.TEXT,
    required: true,
    validation: { min: 3, max: 50 },
  },
  merchantAdminEmail: {
    label: "Admin Email",
    placeholder: "Enter email",
    type: FIELD_TYPES.TEXT,
    required: true,
    validation: { max: 50 },
  },
  merchantAdminPhoneNumber: {
    label: "Admin Phone Number",
    placeholder: "Enter phone number",
    type: FIELD_TYPES.TEXT,
    required: true,
  },
};

export const ADMIN_FIELDS = [
  "merchantAdminFirstName",
  "merchantAdminLastName",
  "merchantAdminEmail",
  "merchantAdminPhoneNumber",
];

export const OBJECT_FIELDS = [
  "economicSector",
  "gender",
  "productTransactionCode",
  "productOwnership",
  "productCategory",
];

export const ALLOWED_EDIT_FIELDS = [
  "merchantName",
  "merchantAlias",
  "registrationNumber",
  "nationality",
  "address",
  "country",
  "city",
  "county",
  "taxPin",
  "directors",
  "shareholders",
  "merchantType",
  "currency",
  "registrationDate",
  "email",
  "phoneNumber",
  "economicSector",
  "gender",
  "productTransactionCode",
  "productOwnership",
  "productCategory",
];

export const getAllFieldKeys = () => Object.keys(MERCHANT_FIELDS);

export const getMerchantDetailFields = () =>
  Object.keys(MERCHANT_FIELDS).filter((key) => !ADMIN_FIELDS.includes(key));

export const isObjectField = (fieldKey) => OBJECT_FIELDS.includes(fieldKey);

export const getFieldConfig = (fieldKey) => MERCHANT_FIELDS[fieldKey];

export default MERCHANT_FIELDS;
